'use client';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { replyHandlerProps } from '@modules/comment/comment.props';
import { TokenProps } from '@modules/comment/comment-form/comment-form.props';
import Comment from '@modules/comment';
import { AlertActions } from '@store/alert/alert-action';
import { useDispatch, useSelector } from 'react-redux';
import { PostCommentProps } from './post-comment.props';
import postFetchCommentsListApi from '@api/posts/post-get-item-comments';
import postSubmitCommentApi from '@api/posts/post-submit-comment';
import { RootState } from '@store/root-reducer';

const PostComment = ({ list, postId, lastPage, currentPage }: PostCommentProps) => {
  const dispatch = useDispatch();
  const { userInfo, email } = useSelector((state: RootState) => state.auth);
  const [comments, setComments] = useState<{currentPage: number, lastPage: number, loading: boolean, list:Array<any> }>({
    currentPage: currentPage,
    lastPage: lastPage,
    loading: false,
    list: list,
  });

  useEffect(() => {
    setComments({
      list: list,
      currentPage: currentPage,
      lastPage: lastPage,
      loading: false,
    });
  }, [list]);

  const [newComment, setNewComment] = useState<{
    value: string,
    parentId: string | number,
    parentName: string,
    loading: boolean,
  }>({
    value: '',
    parentId: '',
    parentName: '',
    loading: false,
  });

  const replyHandler = ({ id, name }: replyHandlerProps) => {
    setNewComment({
      ...newComment,
      parentId: id,
      parentName: name,
    });
  };

  const showMoreHandler = async (page: number) => {
    setComments({ ...comments, loading: true });
    try {
      const response = await postFetchCommentsListApi({ id: postId, page: page, cache: 'no-cache' });
      setComments({
        list: [...comments.list, ...response?.data?.data],
        currentPage: response?.data?.current_page,
        lastPage: response?.data?.last_page,
        loading: false,
      });
    } catch (e: any) {
      setComments({ ...comments, loading: false });
      dispatch(AlertActions.showAlert({ severity: 'danger', text: e.message || 'در دریافت نظرات مشکلی پیش آمده. لطفا مجددا تلاش کنید' }));
    }
  };

  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    setNewComment({ ...newComment, value: e?.target?.value });
  };

  const submitHandler = async ({ token }: TokenProps) => {
    setNewComment({ ...newComment, loading: true });
    if (newComment.value !== '') {
      try {
        await postSubmitCommentApi({
          id: postId,
          email: email,
          userName: userInfo,
          parentId: newComment?.parentId,
          content: newComment?.value,
          token: token,
          cache: 'no-cache',
        });
        setNewComment({ ...newComment, loading: false, parentName: '', parentId: '' });
        dispatch(AlertActions.showAlert({ severity: 'success', text: 'نظر شما با موفقیت ثبت شد.' }));
      } catch (e: any) {
        setNewComment({ ...newComment, loading: false });
        dispatch(AlertActions.showAlert({ severity: 'danger', text: e.message || 'در ثبت نظر شما مشکلی پیش آمد. لطفا مجددا تلاش کنید' }));
      }
    } else {
      dispatch(AlertActions.showAlert({ severity: 'danger', text: 'لطفا ابتدا متن مورد نظر خود را وارد کنید' }));
    }
  };
  return (
    <Comment
      currentPage={comments?.currentPage}
      commentValue={newComment?.value}
      parentName={newComment?.parentName}
      submitLoading={newComment?.loading}
      showMoreLoading={comments?.loading}
      list={comments?.list}
      showMore={comments?.lastPage > comments?.currentPage}
      lastPage={comments?.lastPage}
      showMoreHandler={showMoreHandler}
      replyHandler={replyHandler}
      onChange={onChangeHandler}
      submitHandler={submitHandler}
    />
  );
};

export default PostComment;
